import React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

const NavBar = styled.nav`
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.95);
    border-bottom: 1px solid #e0e0e0;
    backdrop-filter: blur(8px);
`;

const NavInner = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 12px 20px;
    display: flex;
    justify-content: center;
    gap: 24px;
`;

const NavLink = styled(Link)`
    color: ${(props) => (props.$active ? "#0078d7" : "#333")};
    text-decoration: none;
    font-size: 0.95rem;
    font-weight: ${(props) => (props.$active ? "600" : "400")};
    padding-bottom: 2px;
    border-bottom: 2px solid
        ${(props) => (props.$active ? "#0078d7" : "transparent")};
    transition: color 0.2s, border-color 0.2s;

    &:hover {
        color: #0078d7;
    }
`;

const navItems = [
    { label: "Home", path: "/" },
    { label: "About", path: "/About" },
    { label: "Contact", path: "/Contact" },
];

const Nav = () => {
    const location = useLocation();

    return (
        <NavBar>
            <NavInner>
                {navItems.map(({ label, path }) => (
                    <NavLink
                        key={path}
                        to={path}
                        $active={location.pathname === path}
                    >
                        {label}
                    </NavLink>
                ))}
            </NavInner>
        </NavBar>
    );
};

export default Nav;
